/* eslint-disable react/jsx-curly-newline */
/* eslint-disable react/prop-types */
import React from 'react';
// components
import { Button, Input } from '@design-system-coopeuch/web';
import CaseInfo from '../../molecules/CaseInfo/CaseInfo';
// utils
import { isMobile } from '../../../utils/platform';
// styles
import { StyledWraperIconsSurvey, StyledUsabilityAndSatisfaction } from './styles';
import { StyledWrapperInputMaxLength } from '../../../assets/styles/styles';

import iconTooSadFaceEmpty from '../../../assets/img/icon-too-sad-face-empty.svg';
import iconTooSadFaceFull from '../../../assets/img/icon-too-sad-face-full.svg';
import iconVerySadFaceEmpty from '../../../assets/img/icon-very-sad-face-empty.svg';
import iconVerySadFaceFull from '../../../assets/img/icon-very-sad-face-full.svg';
import iconSadFaceEmpty from '../../../assets/img/icon-sad-face-empty.svg';
import iconSadFaceFull from '../../../assets/img/icon-sad-face-full.svg';
import iconSeriousFaceEmpty from '../../../assets/img/icon-serious-face-empty.svg';
import iconSeriousFaceFull from '../../../assets/img/icon-serious-face-full.svg';
import iconHappyFaceEmpty from '../../../assets/img/icon-happy-face-empty.svg';
import iconHappyFaceFull from '../../../assets/img/icon-happy-face-full.svg';
import iconVeryHappyFaceEmpty from '../../../assets/img/icon-very-happy-face-empty.svg';
import iconVeryHappyFaceFull from '../../../assets/img/icon-very-happy-face-full.svg';
import iconTooHappyFaceEmpty from '../../../assets/img/icon-too-happy-face-empty.svg';
import iconTooHappyFaceFull from '../../../assets/img/icon-too-happy-face-full.svg';
import iconStartEmpty from '../../../assets/img/icon-start-empty.svg';
import iconStartFull from '../../../assets/img/icon-start-full.svg';

// constants
const isDeviceMobile = isMobile();
const faceIcons = {
  iconTooSadFaceEmpty,
  iconTooSadFaceFull,
  iconVerySadFaceEmpty,
  iconVerySadFaceFull,
  iconSadFaceEmpty,
  iconSadFaceFull,
  iconSeriousFaceEmpty,
  iconSeriousFaceFull,
  iconHappyFaceEmpty,
  iconHappyFaceFull,
  iconVeryHappyFaceEmpty,
  iconVeryHappyFaceFull,
  iconTooHappyFaceEmpty,
  iconTooHappyFaceFull,
};
const faceIconsNames = [
  'iconTooSadFace',
  'iconVerySadFace',
  'iconSadFace',
  'iconSeriousFace',
  'iconHappyFace',
  'iconVeryHappyFace',
  'iconTooHappyFace',
];

const UsabilityAndSatisfaction = (props) => {
  const {
    state,
    currentEdgeCase,
    optionSelected,
    currentQuestion,
    questions,
    canContinue,
    onClickContinue,
    onSelectOption,
    onChangeComment,
    onExitFlow,
    onRetrySendResponses,
  } = props;
  const qtyQuestions = questions.length;

  return (
    <StyledUsabilityAndSatisfaction>
      {state === 'initial' && (
        <section className="p-0 h-100 d-flex flex-column justify-content-between">
          <article className="px-4 pl-md-6 pr-md-7 py-4 py-md-5 border-bottom border-neutral-alfa-15">
            <p className="text-intro-survaey font-size-20 font-size-md-24 line-height-30 font-weight-bold">
              Tu opinión es muy importante para mejorar tu experiencia y la de nuestros socios.
            </p>
            <p className="text-intro-survaey font-size-20 font-size-md-24 line-height-30 font-weight-bold">
              Contesta por favor:
            </p>
          </article>

          <section className="container-question px-4 px-md-6 py-4 py-md-5">
            <p className="mb-1 mb-md-2 font-size-18 line-height-24">
              {`${currentQuestion} de ${qtyQuestions} pregunta${qtyQuestions > 1 ? 's' : ''}`}
            </p>
            <p className="mb-1 mb-md-2 font-size-18 font-weight-500 line-height-24">
              {questions[currentQuestion - 1].question}
            </p>

            <StyledWraperIconsSurvey>
              {questions[currentQuestion - 1].alternatives.map((el, idx) => (
                <>
                  {questions[currentQuestion - 1].type === 'face' && (
                    <div className="">
                      <button
                        className="btn-without-format--red-underline"
                        type="button"
                        onClick={() => onSelectOption({ idOption: el.idOption, selected: true })}
                      >
                        <img
                          src={
                            optionSelected.idOption && optionSelected.idOption === el.idOption
                              ? faceIcons[`${faceIconsNames[idx]}Full`]
                              : faceIcons[`${faceIconsNames[idx]}Empty`]
                          }
                          alt="face"
                          width="50"
                        />
                      </button>
                    </div>
                  )}
                  {questions[currentQuestion - 1].type === 'start' && (
                    <div>
                      <button
                        className="w-100 btn-without-format--red-underline"
                        type="button"
                        onClick={() => onSelectOption({ ...el, icon: idx })}
                      >
                        <img
                          src={
                            optionSelected.idOption &&
                            parseInt(optionSelected.idOption, 10) >= parseInt(el.idOption, 10)
                              ? // idx <= optionSelected.idOption
                                iconStartFull
                              : iconStartEmpty
                          }
                          alt="start"
                          width="50px"
                        />
                      </button>
                    </div>
                  )}
                </>
              ))}
            </StyledWraperIconsSurvey>
            <article className="w-100 d-flex justify-content-between">
              {questions[currentQuestion - 1].limits.map((ele) => (
                <span className="font-size-12 font-size-md-16">{ele}</span>
              ))}
            </article>
            {questions[currentQuestion - 1].alternatives.map((el) => (
              <>
                {el.comment && el.idOption === optionSelected.idOption && (
                  <article className="mt-3">
                    <StyledWrapperInputMaxLength>
                      <Input
                        className="ipunt-comment-survey"
                        label={el.comment.question}
                        value={optionSelected.comment}
                        maxLength={200}
                        showLength
                        assistText={
                          el.comment.required
                            ? [{ text: 'Campo obligatorio', type: 'assist' }]
                            : [{ text: 'Campo opcional', type: 'assist' }]
                        }
                        onChange={(value) =>
                          onChangeComment({ idOption: el.idOption, comment: value })
                        }
                        allowSpaces
                        autoComplete="new-password"
                      />
                    </StyledWrapperInputMaxLength>
                  </article>
                )}
              </>
            ))}
          </section>
          <article className="w-100 px-4 px-md-6 py-4 py-md-5 border-top border-neutral-alfa-15 d-flex justify-content-end align-items-center">
            {currentQuestion === qtyQuestions ? (
              <Button
                variant="default"
                disabled={!canContinue}
                onClick={() => onClickContinue()}
              >
                Enviar y terminar
              </Button>
            ) : (
              <Button
                variant="text"
                suffix="arrow-right"
                disabled={!canContinue}
                onClick={() => onClickContinue()}
              >
                Enviar y continuar
              </Button>
            )}
          </article>
        </section>
      )}
      {state === 'sent' && (
        <CaseInfo
          edgeCase={currentEdgeCase}
          isMobile={isDeviceMobile}
          onClickButton={() => onExitFlow('usabilityAndSatisfaction')}
        />
      )}
      {state === 'error' && (
        <CaseInfo
          edgeCase={currentEdgeCase}
          isMobile={isDeviceMobile}
          onClickButton={onRetrySendResponses}
        />
      )}
    </StyledUsabilityAndSatisfaction>
  );
};

export default UsabilityAndSatisfaction;
